import { END_POINTS } from '@config';
import { api } from '@core/baseApi';
import { HTTPResponse } from '@types';

const extendedBaseQuery = api.injectEndpoints({
  endpoints: (builder) => ({
    updateOrgConfig: builder.mutation<
      HTTPResponse<any>,
      { organizationId: string; body: any }
    >({
      query: (reqBody) => ({
        url: END_POINTS.ORGANIZATION.UPDATE_ORG_CONFIG(reqBody.organizationId),
        method: 'POST',
        body: reqBody.body
      })
    }),
    getAllWebhooks: builder.query<HTTPResponse<any>, { queryParms: string }>({
      query: (req) => ({
        url: `${END_POINTS.ORGANIZATION.GET_ALL_WEBHOOKS}${req.queryParms}`,
        method: 'GET'
      })
    }),
    getAllSupportedEvents: builder.query<HTTPResponse<any>, any>({
      query: () => ({
        url: END_POINTS.ORGANIZATION.GET_ALL_SUPPORTED_EVENTS,
        method: 'GET'
      })
    }),
    createWebhook: builder.mutation<HTTPResponse<any>, { body: any }>({
      query: (req) => ({
        url: END_POINTS.ORGANIZATION.CREATE_WEBHOOK,
        method: 'POST',
        body: req.body
      })
    }),
    getWebhookById: builder.query<
      HTTPResponse<any>,
      { queryParms: string; webhookId: string }
    >({
      query: (req) => ({
        url: `${END_POINTS.ORGANIZATION.GET_WEBHOOK_BY_ID(req.webhookId)}${
          req.queryParms
        }`,
        method: 'GET'
      })
    }),
    updateWebhook: builder.mutation<
      HTTPResponse<any>,
      {
        webhookId: string;
        body: any;
      }
    >({
      query: (req) => ({
        url: END_POINTS.ORGANIZATION.UPDATE_WEBHOOK(req.webhookId),
        method: 'PUT',
        body: req.body
      })
    }),
    deleteWebhook: builder.mutation<HTTPResponse<any>, { webhookId: string }>({
      query: (req) => ({
        url: END_POINTS.ORGANIZATION.DELETE_WEBHOOK(req.webhookId),
        method: 'DELETE'
      })
    }),
    getAllApiKeys: builder.query<HTTPResponse<any>, { queryParms: string }>({
      query: (req) => ({
        url: `${END_POINTS.ORGANIZATION.GET_ALL_API_KEYS}${req.queryParms}`,
        method: 'GET'
      })
    }),
    updateApiKey: builder.mutation<
      HTTPResponse<any>,
      { apiId: string; body: any }
    >({
      query: (req) => ({
        url: END_POINTS.ORGANIZATION.UPDATE_API_KEY(req.apiId),
        method: 'PUT',
        body: req.body
      })
    }),
    createApiKey: builder.mutation<HTTPResponse<any>, { body: any }>({
      query: (req) => ({
        url: END_POINTS.ORGANIZATION.CREATE_API_KEY,
        method: 'POST',
        body: req.body
      })
    }),
    deleteApiKey: builder.mutation<HTTPResponse<any>, { apiId: string }>({
      query: (req) => ({
        url: END_POINTS.ORGANIZATION.DELETE_API_KEY(req.apiId),
        method: 'DELETE'
      })
    }),
    getProviders: builder.query<HTTPResponse<any>, null>({
      query: () => ({
        url: END_POINTS.ORGANIZATION.GET_PROVIDERS,
        method: 'GET'
      })
    }),
    getSampleTemplates: builder.query<HTTPResponse<any>, null>({
      query: () => ({
        url: END_POINTS.ORGANIZATION.GET_SAMPLE_TEMPLATES,
        method: 'GET'
      })
    }),
    updateProvider: builder.mutation<
      HTTPResponse<any>,
      { body: any; organizationId: string }
    >({
      query: (req) => ({
        url: END_POINTS.ORGANIZATION.UPDATE_PROVIDER_CONFIG(req.organizationId),
        method: 'POST',
        body: req.body
      })
    }),
    getProviderConfig: builder.query<
      HTTPResponse<any>,
      { organizationId: string }
    >({
      query: (req) => ({
        url: END_POINTS.ORGANIZATION.GET_PROVIDER_CONFIG(req.organizationId),
        method: 'GET'
      })
    }),
    updateTemplateConfig: builder.mutation<
      HTTPResponse<any>,
      { body: any; organizationId: string }
    >({
      query: (req) => ({
        url: END_POINTS.ORGANIZATION.UPDATE_TEMPLATE_CONFIG(req.organizationId),
        method: 'POST',
        body: req.body
      })
    }),
    getTemplateConfig: builder.query<
      HTTPResponse<any>,
      { organizationId: string; providerId: string }
    >({
      query: (req) => ({
        url: END_POINTS.ORGANIZATION.GET_TEMPLATE_CONFIG(
          req.organizationId,
          req.providerId
        ),
        method: 'GET'
      })
    })
  })
});

// eslint-disable-next-line import/prefer-default-export
export const {
  useUpdateOrgConfigMutation,
  useLazyGetAllWebhooksQuery,
  useLazyGetAllSupportedEventsQuery,
  useCreateWebhookMutation,
  useLazyGetWebhookByIdQuery,
  useUpdateWebhookMutation,
  useDeleteWebhookMutation,
  useLazyGetAllApiKeysQuery,
  useUpdateApiKeyMutation,
  useCreateApiKeyMutation,
  useDeleteApiKeyMutation,
  useLazyGetProvidersQuery,
  useLazyGetSampleTemplatesQuery,
  useUpdateProviderMutation,
  useLazyGetProviderConfigQuery,
  useUpdateTemplateConfigMutation,
  useLazyGetTemplateConfigQuery
} = extendedBaseQuery;
